import React from "react";
import {
  Grid,
  List,
  ListItem,
  Paper,
  Link,
  Typography,
} from '@material-ui/core'
import { ListHistoryPermissions } from "./ListHistoryPermissions.js";
import SearchUserPerm from './containers/SearchUserPerm';
import { Help } from '@material-ui/icons';
import SubsectionTooltip from './SubsectionTooltip';

export class Permissions extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      isModalHisPermOpen: false
    };
  }

  componentDidMount() {
    document.title = "GO | Permisos";
  }

  handleHisPermModal = () => {
    this.setState({ isModalHisPermOpen: !this.state.isModalHisPermOpen })
  }

  render() {
    const { isModalHisPermOpen } = this.state
    const { can_grant } = this.props

    let sections = null;
    if(can_grant === 'true'){
      sections = (
        <React.Fragment>
          <LinkHistory handleHisPermModal={this.handleHisPermModal}/>
          <Section
            type='Create'
            header='Permiso para firmar oficios'
            title='Al agregar uno o más usuarios a esta sección, dichos usuarios podrán redactar y firmar oficios.'
            description='Asignar permiso para firmar oficios a:' />
          <Section
            type='Grant'
            header='Permiso para que un usuario otorgue permisos'
            title='Al agregar uno o más usuarios a esta sección dichos usuarios podrán autorizar a terceros para redactar y firmar oficios.'
            description='Asignar a un usuario para que éste otorgue permisos:'/>
          <ListHistoryPermissions onClose={this.handleHisPermModal} open={isModalHisPermOpen} />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
      {sections}
      </React.Fragment>
    );
  }
}

const Section = props => {
  const { type, title, description, header } = props;
  return(
    <Grid container style={{ marginBottom: 20}}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Paper className="subsection_container">
          <div>
            <List>
              <ListItem>
                <Grid container justify="space-between">
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography variant="h5" className="subsection_header">{header}
                        <SubsectionTooltip
                           placement="right"
                           title={
                             <React.Fragment>
                               <p>{title}</p>
                             </React.Fragment>
                           }>
                        <Help color="primary" fontSize="small" style={{ paddingTop: 5 }} />
                      </SubsectionTooltip>
                      </Typography>
                    <Typography variant="subtitle2">{description}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <SearchUserPerm
                      type={type}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </div>
        </Paper>
      </Grid>
    </Grid>
  )
}

const LinkHistory = props => {
  const { handleHisPermModal } = props;
  return(
    <Typography align="right" variant="caption">
      <Link href="#" className="link_permissions_history"
        onClick={handleHisPermModal}>
        Ver historial de permisos
      </Link>
    </Typography>
  )
}

Permissions.propTypes = {};
export default Permissions;



// WEBPACK FOOTER //
// ./src/components/Permissions.js